import * as React from 'react';
import * as ReactDOM from 'react-dom';
import DesAddPartToLibraryViewModel from 'viewmodel/DesAddPartToLibraryViewModel';
import { AppCtxComponent } from 'js/reactAppCtx';


/* Class add part to library */
export default class DesAddPartToLibrary extends HTMLElement {

    /*Render Function */

    render(context) {
        ReactDOM.render(
            <AppCtxComponent>
                {context.createReactElement()}
            </AppCtxComponent>, context);
    }
    /**
     * Lifecycle function invoked when the custom html
     * element is rendered
     */
     connectedCallback() {
        this.applyDefaultStyling();
        this.render(this);
    }

    applyDefaultStyling() {
        this.style.height = '100%';
        this.className = 'afx-content-background';
    }

    /**
     * Helper function
     */
    createReactElement(){
        return React.createElement( DesAddPartToLibraryViewModel, {
            accsessionid : this.accSessionId,
            collaborationspaceid:this.collaborationspaceId,
            provider:this.provider,
            part:this.part,
            catalogspaceid: this.catalogspaceId
        }, React.createElement( 'slot' ) );


    }

    get accSessionId() {
        return this.getAttribute('acc-session-id') || this.getAttribute('accsessionid') || this.getAttribute('acc-id');
    }
    get collaborationspaceId() {
        return this.getAttribute('collaborationspace-id') || this.getAttribute('collaborationspaceid');
    }
    get provider() {
        return this.getAttribute('provider');
    }
    get part() {
        return this.getAttribute('part');
    }
    get catalogspaceId() {
        return this.getAttribute('catalog-space-id') || this.getAttribute('catalogspaceid') || this.getAttribute('catalogspace-id');
    }
    get locale () {
		return this.getAttribute('locale') || 'en_US';
    }
    static get observedAttributes() {
        return [
            'locale',
            'acc-session-id', 'acc-id', 'accsessionid',
            'collaborationspaceid', 'provider', 'part',
            'catalogspaceid', 'catalog-space-id'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        this.debounceCreateElement();
    }

    debounceCreateElement() {
        const _this = this;
        if (_this.debounceFuncRef) {
            clearTimeout(_this.debounceFuncRef);
        }
        _this.debounceFuncRef = setTimeout(() => this.render(_this), 1000);
    }

    disconnectedCallback() {
        ReactDOM.render(null, this);
    }
}
if (!window.customElements.get('des-add-part-to-library')) {
    window.customElements.define('des-add-part-to-library', DesAddPartToLibrary);
}
